import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
export function About() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section id="about" ref={ref} className="py-24 lg:py-32 bg-ink" data-id="element-14">
      <div className="max-w-6xl mx-auto px-6 lg:px-12" data-id="element-15">
        <motion.div initial={{
        opacity: 0,
        y: 40
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.8
      }} className="grid lg:grid-cols-2 gap-12 lg:gap-20 items-center" data-id="element-16">
          {/* Image */}
          <div className="relative" data-id="element-17">
            <div className="relative aspect-[3/4] w-full" data-id="element-18">
              <div className="absolute -inset-4 border border-gold/20" data-id="element-19"></div>
              <div className="absolute -top-4 -left-4 w-16 h-16 border-t border-l border-gold/60" data-id="element-20"></div>
              <div className="absolute -bottom-4 -right-4 w-16 h-16 border-b border-r border-gold/60" data-id="element-21"></div>
              <img src="https://cdn.magicpatterns.com/uploads/qAT7XzF4TkZKh6Q7WmphkG/12.jpg" alt="Madam Yas" className="relative w-full h-full object-cover object-center" data-id="element-22" />
              <div className="absolute inset-0 bg-gradient-to-t from-ink/20 via-transparent to-transparent pointer-events-none" data-id="element-23"></div>
            </div>
          </div>

          {/* Content */}
          <div data-id="element-24">
            <p className="text-gold text-xs uppercase tracking-[0.3em] mb-4 font-cinzel" data-id="element-25">
              About Madam Yas
            </p>
            <h2 className="font-cormorant text-bone text-4xl lg:text-5xl font-light mb-6 leading-tight" data-id="element-26">
              Expertise, Intuition,
              <br data-id="element-27" />
              and Unwavering Presence
            </h2>
            <div className="space-y-4 text-silver-muted leading-relaxed" data-id="element-28">
              <p data-id="element-29">
                With years of experience in the art of professional dominance, I
                bring a unique blend of psychological insight, physical skill,
                and emotional intelligence to every session.
              </p>
              <p data-id="element-30">
                My approach is rooted in trust, communication, and mutual
                respect. I create a safe container for exploration,
                transformation, and the deepest forms of surrender.
              </p>
              <p data-id="element-31">
                As a Black-owned practice, I am committed to creating inclusive,
                affirming spaces for all who seek authentic power exchange
                experiences.
              </p>
              <p className="text-silver font-medium pt-4" data-id="element-32">
                Whether you are new to BDSM or a seasoned practitioner, I offer
                tailored experiences that honor your boundaries while pushing
                you toward profound personal growth.
              </p>
            </div>

            <div className="mt-8 pt-8 border-t border-gold/20" data-id="element-33">
              <div className="grid grid-cols-2 gap-6" data-id="element-34">
                <div data-id="element-35">
                  <p className="text-gold text-xs uppercase tracking-widest mb-2" data-id="element-36">
                    Experience
                  </p>
                  <p className="text-bone font-cormorant text-2xl" data-id="element-37">7+ Years</p>
                </div>
                <div data-id="element-38">
                  <p className="text-gold text-xs uppercase tracking-widest mb-2" data-id="element-39">
                    Specialty
                  </p>
                  <p className="text-bone font-cormorant text-2xl" data-id="element-40">
                    Power Exchange
                  </p>
                </div>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}